import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";
import { StandardTableSortablePropertyHeader } from "../../../components/tables/StandardTable";

const FixedHeader = styled(StandardTableSortablePropertyHeader)`
    ${({ width }) => width ? `width: ${width}%;` : ""}
`;

const AdviceRegisterTableHeader = ({ currentSort, sortTable }) => {
    const Header = ({ children, ...props }) => <FixedHeader
        {...props}
        sort={currentSort}
        sortTable={sortTable}
        className="text-truncate"
    >
        {children}
    </FixedHeader>

    return <thead>
        <tr>
            <Header width={8} property={'adviser'}>
                Adviser
            </Header>
            <Header width={10} property={'masterAccountName'}>Client</Header>
            <Header width={2} property={'isVulnerable'}>
                {<OverlayTrigger overlay={<Tooltip>Vulnerable</Tooltip>}>
                    <FontAwesomeIcon
                        size="xs"
                        icon={"fa-flag"}
                        color={"red"}
                    />
                </OverlayTrigger>}
            </Header>
            <Header width={9} property={'serviceLevelAgreement'}>Service</Header>
            <Header width={6} property={'reviewDate'}>Review</Header>
            <Header width={11} property={'reportName'}>Report</Header>
            <Header width={8} property={'author'}>
                Author
            </Header>
            <Header width={8} property={'complianceUser'}>
                Compliance Officer
            </Header>
            <Header width={1} property={'rejectCount'}>
                Rejected
            </Header>
            <Header width={6} property={'compliantDate'}>Compliance</Header>
            <Header width={6} property={'sentDate'}>Sent</Header>
            <Header width={7} property={'adminStatus'}>Admin</Header>
        </tr>
    </thead>
}

export default AdviceRegisterTableHeader;